<template>
  <a-row class="info-item">
    <a-col :md="6" class="info-item__label">{{ label }}</a-col>
    <a-col :md="18" class="info-item__value" :style="{ color: keyInfo === 'files' ? '#0379B0' : '#29444F' }">
      <a-row v-if="typeof value === 'string' && keyInfo === 'status'">
        <span
          class="status-wrapper"
          :style="{ backgroundColor: getStatus(value).color, color: getStatus(value).text_color }"
        >
          {{ value }}
        </span>
      </a-row>
      <a-row v-else-if="typeof value === 'object'" v-for="(item, index) in value" :key="index" :gutter="[6, 6]">
        <a-col span="24">
          <span v-if="keyInfo === 'files'" class="file-wrapper" @click="downLoadFile(item)">
            <span>
              {{ item }}
            </span>
          </span>
          <div v-else>
            {{ item }}
          </div>
        </a-col>
      </a-row>
      <a-row v-else>
        {{ value }}
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import { getStatus } from "../commons/commons";
export default {
  name: "InfoIFlexibleItem",
  props: {
    keyInfo: String,
    label: String,
    value: [String, Array, Number],
    downLoadFile: Function,
  },
  data() {
    return {};
  },
  methods: {
    getStatus,
    generateValue(_, value) {
      return value;
    },
  },
};
</script>

<style lang="scss">
.info-item {
  border-bottom: 2px solid #cdebf9;
  padding: 12px 0;
  margin-bottom: 20px;
  &__label,
  &__value {
    font-weight: 400;
    font-size: 14px;
  }
  /* &__label {
    color: #61757d;
  }
  &__value {
    color: #29444f;
  } */

  .status-wrapper {
    opacity: 0.8;
    border-radius: 20px;
    padding: 6px 12px;
    font-weight: 700;
    font-size: 14px;
  }
  .file-wrapper {
    display: inline-block;
    background: #edeff0;
    border-radius: 6px;
    height: 24px;
    span {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
    }
  }
}
</style>
